import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'Components';
import AppContext from 'src/AppContext';
import './Header.css';


const isNotSortable = ['completedCount', 'CompletedSamples'];

const sortIcon = (sort, keyVal) => {
  if (sort === undefined) return <i className="material-icons" style={{ visibility: 'hidden' }}>arrow_drop_up</i>;
  if (sort.substring(1) !== keyVal) return <i className="material-icons" style={{ visibility: 'hidden' }}>arrow_drop_up</i>;

  return <i className="material-icons">{sort.charAt(0) === '-' ? 'arrow_drop_up' : 'arrow_drop_down'}</i>;
};

const Header = (props) => {
  const handleClick = () => {
    let newSort;
    if (props.sort === undefined || props.sort.substring(1) !== props.keyVal) {
      newSort = `-${props.keyVal}`;
    } else if (props.sort.charAt(0) === '-') {
      newSort = `+${props.keyVal}`;
    }

    if (props.hasManualSort) {
      return props.handleSortClick(newSort);
    }

    return props.setAppState(prevState => ({
      [props.code]: {
        ...prevState[props.code],
        sort: newSort,
        shouldLoad: true,
        pageNumber: 1,
      },
    }));
  };

  return (
    <th
      className={`${classNames({ 'header--sortable': props.sortable, 'header__onhover--active': props.isHoverActive })} ${props.className}`}
      style={{ paddingRight: props.paddingRight }}
      draggable={props.isDraggable}
      onDragStart={props.onDragStart}
      onDragOver={props.onDragOver}
      onDragEnd={props.onDragEnd}
      data-id={props.index}
    >
      {props.sortable && !isNotSortable.includes(props.keyVal) ?
        <Button dataId={props.index} draggable={props.isDraggable} className={`${props.padLeft ? 'header--pad-left' : ''}`} onClick={handleClick}>
          {props.children}
          {sortIcon(props.sort, props.keyVal)}
        </Button> :
        <Button dataId={props.index} draggable={props.isDraggable} className={`header ${props.padLeft ? 'header--pad-left' : ''}`}>
          {props.children}
        </Button>
      }
    </th>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  keyVal: PropTypes.string,
  sort: PropTypes.string,
  sortable: PropTypes.bool,
  code: PropTypes.string,
  setAppState: PropTypes.func,
  padLeft: PropTypes.bool,
  paddingRight: PropTypes.string,
  onDragStart: PropTypes.func,
  onDragOver: PropTypes.func,
  onDragEnd: PropTypes.func,
  index: PropTypes.number,
  isDraggable: PropTypes.bool,
  isHoverActive: PropTypes.bool,
  className: PropTypes.string,
  handleSortClick: PropTypes.func,
  hasManualSort: PropTypes.bool,
};

Header.defaultProps = {
  sortable: false,
  onDragStart: () => { },
  onDragOver: () => { },
  className: '',
};

export default props => (
  <AppContext.Consumer>
    {context => (
      <Header
        {...props}
        setAppState={context.setAppState}
      />
    )}
  </AppContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx